import toast from 'react-hot-toast';
import { call, put, takeEvery } from 'redux-saga/effects';
import { showToast } from 'helpers';
import { setApiStatus } from '../reducers/globals/globalActions';
import { RESTCallError, sendPutRequest } from './utils';
import { store } from '../store';
import { setLoginSuccess } from '../reducers/login/loginActions';

function putApi(body, apiName, url, extras) {
	return {
		type: 'PUT_API_DATA',
		url: url,
		body: body,
		apiName: apiName,
		extras: extras,
	};
}

function* putApiDataSaga() {
	yield takeEvery('PUT_API_DATA', putApiDataWorker);
}

function* putApiDataWorker(param) {
	let apiName = param.apiName;
	try {
		store.dispatch(setApiStatus(apiName, 'PENDING'));

		const result = yield call(sendPutRequest, param);
		if (result.status >= 200 && result.status <= 204) {
			yield putApiDataSuccess(result.data, apiName, param.extras);
		} else if (result.status === 'Error') {
			toast.error(result?.error?.response?.data?.message || 'Something went wrong!');
			RESTCallError(result, apiName);
		}
	} catch (error) {
		console.log(param);
		console.log(error);
		console.log({ ...error });
	}
}

function* putApiDataSuccess(response, apiName, extras) {
	switch (apiName) {
		case 'EDIT_USER':
			yield put(setLoginSuccess(response));
			break;
		case 'EDIT_CUSTOMER':
			// Store the response for components to access
			yield put({
				type: 'SET_API_RESPONSE',
				payload: {
					[apiName]: response
				}
			});
			break;
		case 'EDIT_WORKOUT':
		case 'EDIT_WORKOUT_TEMPLATE':
		case 'PAUSE_WORKOUT_PLAN':
		case 'RESUME_WORKOUT_PLAN':
		case 'CANCEL_WORKOUT_PLAN':
			break;
		default:
			break;
	}
	yield showToast("Success", "Updated Successfully!!");
	yield put(setApiStatus(apiName, 'SUCCESS'));
}

export { putApi, putApiDataSaga };
